import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { safeReturnTo } from '../utils/googleAuth';

export function ReturnAfterLogin() {
  const location = useLocation();
  return <Navigate to={safeReturnTo(location.state?.from)} replace />;
}

export default function RequireAuth({ children }) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  return children ?? <Outlet />;
}
